import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ca5e01a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 실제 판매 예정 내역 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 판매 금액 = ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 좌 수 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" X 가격 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { translucent: true }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, { p: "20px" }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            typography: "tit16b",
            color: "white"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, {
            bg: "#313131",
            p: "16px",
            my: "16px",
            style: {"border-radius":"4px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                typography: "main16r",
                color: "white"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_ag_text, {
                    typography: "tit16b",
                    color: "#00B7B9"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            typography: "main14r",
            color: "gray3",
            display: "block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`조합원 자격 거래는 조합지분의 최종 단위인 1좌 단위(자연수)로 거래가 가능합니다.(소수점 이하 단위로는 거래할 수 없습니다.)\n입력해주신 판매 희망 가격과 판매 희망 금액으로 판매 예상 지분 수(좌)를 계산한 후, 실제 판매가 1좌 단위가 될 수 있도록 판매 가격과 판매 금액을 최대한 가까운 수치로 재계산하여 판매 등록 해드립니다.`), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}